import { Component, ViewChild, ViewContainerRef, ChangeDetectionStrategy } from '@angular/core';
import { IAfterGuiAttachedParams } from 'ag-grid-community';

import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AbstractCheckboxFilterComponent } from '@app/shared/classes/ag-checkbox-filter';

@Component({
  selector: 'app-search-and-checkbox-filter',
  templateUrl: './search-and-checkbox-filter.component.html',
  styleUrls: ['../ag-filters.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchAndCheckboxFilterComponent extends AbstractCheckboxFilterComponent {
  @ViewChild('input', { read: ViewContainerRef, static: true }) input: ViewContainerRef;

  private _searchTextSubject = new BehaviorSubject<string>('');
  readonly searchText$ = this._searchTextSubject.asObservable();

  text = '';

  onSearchTextChange(newValue: string): void {
    this._searchTextSubject.next(newValue);
  }

  afterGuiAttached(params: IAfterGuiAttachedParams): void {
    this.input.element.nativeElement.focus();
  }

  doesPartialMatchPass(checkboxValue: string): Observable<boolean> {
    return this.searchText$.pipe(
      map((text) => {
        return text
          .toLowerCase()
          .split(' ')
          .every((filterWord) => checkboxValue.toLowerCase().indexOf(filterWord) >= 0);
      })
    );
  }
}
